import { useQuery } from '@tanstack/react-query';
// Service
import {
  getAdminUsersList, getAdminRolesList, getAdminUser, getConfirmEmailAddress,
} from './parazolService';

/**
 * @description Get the list of admin users.
 * @param {object} queryParams
 * @param {number} queryParams.pageNumber
 * @param {number} queryParams.pageSize
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * {data: AdminUser[], pagination: Pagination}, Error>}
 */
export const useGetAdminUsersListQuery = (queryParams, options) => useQuery({
  queryKey: ['admin-users', queryParams],
  queryFn: () => getAdminUsersList(queryParams),
  ...options,
});

/**
 * @description Get the list of admin roles.
 * @param {object} queryParams
 * @param {number} queryParams.pageNumber
 * @param {number} queryParams.pageSize
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * {data: AdminRole[], pagination: Pagination}, Error>}
 */
export const useGetAdminRolesListQuery = (queryParams, options) => useQuery({
  queryKey: ['admin-roles', queryParams],
  queryFn: () => getAdminRolesList(queryParams),
  ...options,
});
/**
 * @description Get an Admin User from its ID.
 * @param {string} userId
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * AdminUser, Error>}
 */
export const useGetAdminUserQuery = (userId, options) => useQuery({
  queryKey: ['admin-user', userId],
  queryFn: () => getAdminUser(userId),
  ...options,
});
/**
 * @description Get to confirm email adresse.
 * @param {string} redirectUrl
 * @param {string} token
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * import("axios").AxiosResponse, Error>}
 */
export const useGetConfirmEmailAddressQuery = (redirectUrl, token, options) => useQuery({
  queryKey: ['confirm-email', token],
  queryFn: () => getConfirmEmailAddress(redirectUrl, token),
  ...options,
});
